import ReactDOMServer from "react-dom/server";
import { CLICK_ACTIONS } from "../../utils/Constant";
import { ColumnHeaderType } from "../../utils/Types";
import { blankValueGetter, getPermissionsClass, getRoleStatusClass, lobValueGetter, roleStatusValueGetter } from "../../utils/Util";
import { Input } from "reactstrap";

export const ROLE_MASTER_HEADERS: ColumnHeaderType[] = [
    // {
    //     name: 'Role ID',
    //     field: 'id',
    //     sortable: false,
    //     valueGetter: blankValueGetter,
    //     action: CLICK_ACTIONS.VIEW_PERMISSIONS,
    //     clickable: true,
    // },  
    {
        name: 'Role Name',
        field: 'name',
        sortable: false,
        valueGetter: blankValueGetter,
        action: CLICK_ACTIONS.VIEW_PERMISSIONS,
        clickable: true,
    },
    {
        name: 'Role Description',
        field: 'description',
        sortable: false,
        valueGetter: blankValueGetter,
        clickable: false,
    },
    {
        name: 'Role Status',
        field: 'status',
        sortable: false,
        valueGetter: roleStatusValueGetter,
        clickable: false,
    },
    {
        name: 'Line of Business',
        field: 'lobId',
        sortable: false,
        valueGetter: lobValueGetter,
        clickable: false,
    },
];

export const ROLE_PERMISSION_HEADERS: ColumnHeaderType[] = [
    {
        name: 'Functionalities',
        field: 'functionality',
        sortable: false,
        valueGetter: blankValueGetter,
        clickable: false,
        classNameGetter: getPermissionsClass
    },  
    {
        name: 'Applicable',
        field: 'applicable',
        sortable: false,
        valueGetter: blankValueGetter,
        action: CLICK_ACTIONS.SET_PERMISSIONS,
        clickable: true,
    }
];